import React from 'react';

import Notification from './Notification';

import './NotificationList.scss';
import { NotificationData } from '../../../types/notification';

interface NotificationListProps {
  notifications: NotificationData[];
  onNotificationRead: (notification: NotificationData) => void;
}

function NotificationList({ notifications, onNotificationRead }: NotificationListProps) {
  const notificationList = React.Children.toArray(
    notifications
      .map(notification => {
        return <Notification notification={notification} onNotificationRead={onNotificationRead} />;
      })
      .reverse()
  );

  return (
    <div className="notification-list-container">
      {notificationList.length > 0 ? notificationList : <p className="up-to-date">You are up to date!</p>}
    </div>
  );
}

export default NotificationList;
